import useReportStore from '../../../store/reports';

import { Radio, RadioGroup, FormControlLabel } from '@mui/material';

import { strToBool, boolToStr } from "../../../utils/util";

const RadioOptions = ({ field, options, row = true, staticOption = false, defaultValue }) => {
  const reportType = useReportStore(state => state.reportType);

  const handleFilter = useReportStore(state => state.handleFilter);
  const filters = useReportStore(state => state.filters);

  const handleStaticFilters = useReportStore(state => state.handleStaticFilters);
  const staticFilters = useReportStore(state => state.staticFilters);

  const value = staticOption ? staticFilters[reportType]?.[field] : filters[reportType]?.[field]?.$eq;

  const handleChange = (e) => {
    if (staticOption) {
      handleStaticFilters(reportType, field, e.target.value);
    } else {
      handleFilter(e, reportType, field, "$eq");
    }
  }

  return (
    <RadioGroup
      defaultValue={defaultValue}
      value={value}
      onChange={handleChange}
      row={row}
    >
      {options.map((option, index) => (
        <FormControlLabel key={index} value={option.value} control={<Radio />} label={option.label} />
      ))}
    </RadioGroup>
  )
};

export default RadioOptions;